import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { getHouseKeepingDefaultDetails_action, getHouseKeepingDetails_action, insertUpdateHouseKeeping_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/houseKeeping_action/houseKeeping_action'
import Modal from "react-modal";
import { data } from "jquery";
import moment from "moment";
import $ from 'jquery'
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
// 
class HousekeepingConnection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      AccountNumber: "",
      BankName: "",
      BeneficiaryAddress: "",
      BeneficiaryName: "",
      GSTNumber: "",
      IFSCCodeValue: "",
      PANNumber: "",
      SwiftCode: "",
      tableList: [],
      totalAmount: "",
      IGST: "",
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
      contactDetailsList: [],
      exhDetails: [],
      tariffList: [],
      CurrencyID: 1,
      IsIGST: 0,
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)

    this.handleConfirmation = this.handleConfirmation.bind(this)
    this.handleTariffChange = this.handleTariffChange.bind(this)
    this.calcTotals = this.calcTotals.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.insertUpdateHouseKeeping()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getHouseKeepingDefaultDetails()
    this.loadscript()
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }


  sumOfArrayOfObject(arrayOfObjects) {
    const sum = arrayOfObjects.reduce((accumulator, currentObject) => {
      return accumulator + currentObject.Amount;
    }, 0);
    this.setState({ totalAmount: sum })
  }

  handleCancel() {
    window.history.back()
  }

  inputValidate() {
    const { Is_Agree } = this.state
    console.log("Is_Agree", Is_Agree)

    if (Is_Agree == 0 || Is_Agree == false || Is_Agree == undefined) {
      this.setState({ Is_AgreeErr: 'kindly agree the disclaimer & Service Partner Terms and conditions mentioned in Guideline.' })
    }
  }

  getHouseKeepingDefaultDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getHouseKeepingDefaultDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          this.setState({
            AccountNumber: data.bankDetails[0]['AccountNumber'],
            BankName: data.bankDetails[0]['BankName'],
            BeneficiaryAddress: data.bankDetails[0]['BeneficiaryAddress'],
            BeneficiaryName: data.bankDetails[0]['BeneficiaryName'],
            IFSCCodeValue: data.bankDetails[0]['IFSCCodeValue'],
            GSTNumber: data.bankDetails[0]['GSTNumber'],
            PANNumber: data.bankDetails[0]['PANNumber'],
            SwiftCode: data.bankDetails[0]['SwiftCode'],
            tableList: data.data,
            contactDetailsList: data.contactDetails,
            exhDetails: data.exhDetails && data.exhDetails.length > 0 ? data.exhDetails[0] : {},
          })
          setTimeout(() => {
            this.getHouseKeepingDetails()
          }, 100);
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getHouseKeepingDetails() {
    const { tableList } = this.state
    this.props
      .getHouseKeepingDetails_action()
      .then((data) => {
        if (data.error != 1) {
          const hdrData = data.data && data.data.length > 0 ? data.data[0] : {}
          const gst = data.gstDetails && data.gstDetails.length > 0 ? data.gstDetails[0] : {}
          const CurrencyID = gst.CurrencyID != null ? gst.CurrencyID : 1
          const IsIGST = gst.IsIGST != null ? gst.IsIGST : 0

          const tariffList = data.tariffList ? data.tariffList.map(r => ({
            HouseKeepingId: r.HouseKeepingId,
            Date: r.Date,
            Rate: r.Rate,
            NoOfCleanerDay: r.no_of_cleaner_day != null ? r.no_of_cleaner_day : '',
            NoOfCleanerNight: r.no_of_cleaner_night != null ? r.no_of_cleaner_night : '',
            Amount: r.amount != null ? r.amount : 0,
          })) : []

          this.setState({
            Quantity: hdrData.Quantity || '',
            Remark: hdrData.Remark || '',
            Is_Agree: hdrData.Is_Agree || false,
            CurrencyID,
            IsIGST,
            tariffList,
          })
          setTimeout(() => {
            this.sumOfArrayOfObject(tableList)
          }, 100);
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleTariffChange(index, field, value) {
    const { tariffList } = this.state
    const updated = tariffList.map((row, i) => {
      if (i !== index) return row
      const updatedRow = { ...row, [field]: value === '' ? '' : parseInt(value) || 0 }
      const day = field === 'NoOfCleanerDay' ? (parseInt(value) || 0) : (parseInt(updatedRow.NoOfCleanerDay) || 0)
      const night = field === 'NoOfCleanerNight' ? (parseInt(value) || 0) : (parseInt(updatedRow.NoOfCleanerNight) || 0)
      updatedRow.Amount = (day + night) * (updatedRow.Rate || 0)
      return updatedRow
    })
    this.setState({ tariffList: updated })
  }

  calcTotals() {
    const { tariffList, IsIGST } = this.state
    const totalAmount = tariffList.reduce((sum, r) => sum + (parseFloat(r.Amount) || 0), 0)
    if (IsIGST === 1) {
      return { totalAmount, igst: totalAmount * 0.18, cgst: 0, sgst: 0, grandTotal: totalAmount * 1.18 }
    }
    return { totalAmount, igst: 0, cgst: totalAmount * 0.09, sgst: totalAmount * 0.09, grandTotal: totalAmount * 1.18 }
  }

  insertUpdateHouseKeeping() {
    const { Remark, Is_Agree, Quantity, tariffList } = this.state
    this.inputValidate()
    this.setState({ isLoading: true })
    if (Is_Agree) {
      const ManualFormsID = this.props.location.state?.ManualFormsID || null;
      const ServiceID = this.props.location.state?.ServiceID || null;
      const VendorDetails = this.props.location.state?.VendorDetails || {};
      this.props
        .insertUpdateHouseKeeping_action(
          Remark,
          Is_Agree,
          Quantity,
          ManualFormsID,
          ServiceID,
          VendorDetails,
          tariffList.map(r => ({
            HouseKeepingId: r.HouseKeepingId,
            NoOfCleanerDay: parseInt(r.NoOfCleanerDay) || 0,
            NoOfCleanerNight: parseInt(r.NoOfCleanerNight) || 0,
            Amount: parseFloat(r.Amount) || 0,
          }))
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "House Keeping Form Submitted Successfully"
                : "House Keeping Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!")
      this.inputValidate()
      this.setState({ isLoading: false })
    }
  }

  isQuantity(e, i) {
    const { tableList } = this.state
    const event = e.target.value.replace(/\D/, '')
    tableList.map((data, index) => {
      if (i === index) {
        if (event != '') {
          data.Quantity = event
          data.Amount = data.Rate * event
        } else {
          data.Quantity = ''
          data.Amount = 0
        }
      }
    })
    this.setState({ tableList: tableList })
    this.sumOfArrayOfObject(tableList)
  }

  render() {
    const { isLoading, Is_Agree, Remark, Is_AgreeErr, currentDate, DeadlineDate, AccountNumber,
      BankName,
      BeneficiaryAddress,
      BeneficiaryName,
      GSTNumber,
      IFSCCodeValue,
      PANNumber,
      SwiftCode, tableList, totalAmount, IGST, isOpenConfirmationModal,
      contactDetailsList, Quantity, StatusID, isHideSection, is_View, exhDetails,
      tariffList, CurrencyID, IsIGST,
    } = this.state

    const { totalAmount: tariffTotal, igst, cgst, sgst, grandTotal } = this.calcTotals()
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Housekeeping Connection Application
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <ul style={{ lineHeight: "25px", textAlign: "left", padding: 0 }}>
                        <li>
                          1) The cost/rates and terms & conditions of utilizing the individual
                          services from the given service provider is solely discretion of
                          exhibitors.
                        </li>
                        <li>
                          2) India ITME Society is only information facilitator for the service
                          provider & In no event shall INDIA ITME SOCIETY be liable for any
                          direct, indirect, punitive, incidental, special consequential issues,
                          whatsoever arising out of taking services with the above given service
                          provider.
                        </li>
                      </ul>
                    )}

                    <strong>
                      <p className="m-0">Exhibitor Details:</p>
                    </strong>
                    <div class="table-responsive mb-3">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "30%" }}>
                              <strong>Exhibiting Company Name:</strong>
                            </td>
                            <td>{exhDetails.CompanyName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Booth No.:</strong>
                            </td>
                            <td>{exhDetails.StallName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Hall No.:</strong>
                            </td>
                            <td>{exhDetails.HallName || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Contact Person:</strong>
                            </td>
                            <td>{exhDetails.ContactPerson || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Designation:</strong>
                            </td>
                            <td>{exhDetails.Designation || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Mobile:</strong>
                            </td>
                            <td>{exhDetails.Mobile || "-"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Email ID:</strong>
                            </td>
                            <td>{exhDetails.Email || "-"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <strong>
                      <p className="m-0">Contact Details:.</p>
                    </strong>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {contactDetailsList != "" && contactDetailsList.length > 0 ? (
                        contactDetailsList.map((data) => (
                          <>
                            <div
                              class="table-responsive w-50"
                              style={{
                                backgroundColor: "#ebebeb",
                                marginBottom: "14px",
                                borderRight: "1px solid lightgray",
                              }}
                            >
                              <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                                <p className="m-0">
                                  <strong>Name:</strong> {data.Name}{" "}
                                </p>
                                <p className="m-0">
                                  <strong>Phone:</strong> {data.Phone}
                                </p>
                                <p className="m-0">
                                  <strong>Fax:</strong> {data.Fax}
                                </p>
                                <p className="m-0">
                                  <strong>Mobile No.</strong> {data.Mobile}
                                </p>
                                <p className="m-0">
                                  <strong>Email:</strong> {data.PrimaryEmail}
                                </p>
                                <p className="m-0">
                                  <strong>Alternate E-mail:</strong> {data.SecondaryEmail}
                                </p>
                                <p className="m-0">
                                  <strong>Address:</strong> {data.Address}
                                </p>
                              </div>
                            </div>
                          </>
                        ))
                      ) : (
                        <div
                          class="table-responsive w-50"
                          style={{
                            backgroundColor: "#ebebeb",
                            marginBottom: "14px",
                            borderRight: "1px solid lightgray",
                          }}
                        >
                          <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                            <p className="m-0">No record found </p>
                          </div>
                        </div>
                      )}
                    </div>

                    <ul style={{ lineHeight: "25px", textAlign: "left", marginBottom: "14px", listStyleType: "disc", paddingLeft: "20px" }}>
                      <li style={{ listStyleType: "disc" }}>
                        India Exposition Mart Limited is the authorised official cleaning &amp; housekeeping Service Provider for India ITME 2026.
                      </li>
                      <li style={{ listStyleType: "disc" }}>
                        This Form is applicable only for the Exhibitors and not any other parties working directly or indirectly, with or on behalf of exhibitors.
                      </li>
                    </ul>

                    {!isHideSection && (
                      <div style={{ marginBottom: "14px", textAlign: "left" }}>
                        <strong>
                          <p className="m-0 mb-2" style={{ textAlign: "left" }}>Terms &amp; Conditions</p>
                        </strong>
                        <ol style={{ lineHeight: "25px", paddingLeft: "20px", marginBottom: "10px", textAlign: "left" }}>
                          <li style={{ textAlign: "left" }}>
                            The company reserves the right to refuse any order. Cancellation of orders will only be accepted when made in writing to Customer Service Department no later than 7 business days prior to the commencement of tenancy period. Cancellation of order is subject to a charge at half of standard rate.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            <strong>Booth Cleaning Service Includes:</strong>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "5px", textAlign: "left" }}>
                              <li>Floor cleaning (mop/broom)</li>
                              <li>Emptying waste bins &amp; ashtrays</li>
                              <li>Wiping counters and desktops (not exhibits)</li>
                              <li>one daily service either after or before exhibition hours, each booth per one cleaner.</li>
                            </ul>
                          </li>
                          <li style={{ textAlign: "left" }}>
                            <strong>Shift timings:</strong>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "5px", textAlign: "left" }}>
                              <li>7 am to 7 pm (day shift)</li>
                              <li><strong>7 pm to 7 am (night shift) (Applicable from 28.11.2026 to 02.12.2026)</strong></li>
                            </ul>
                          </li>
                          <li style={{ textAlign: "left" }}>
                            Booth Cleaning Services does not cover removal of oil spillage, paints and other liquids deposited on the floor, walls and other surfaces.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            The final request for Housekeeping must be received by <strong>25.11.2026</strong> for onward intimation to service provider.
                          </li>
                          <li style={{ textAlign: "left" }}>
                            Housekeeping charges are <strong>INR 1375</strong> per cleaner per shift (12 hours).
                          </li>
                          <li style={{ textAlign: "left" }}>
                            <strong>Note: This is only manpower cost. Cost of Consumables/Equipment requirement will be extra)</strong>
                          </li>
                        </ol>

                        <strong>
                          <p className="m-0 mb-2" style={{ textAlign: "left" }}>Please Note:</p>
                        </strong>
                        <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "25px", textAlign: "left" }}>
                          <li>Rates mentioned below are on hire basis and applicable as per dates available.</li>
                          <li>Orders are valid only when accompanied with full payment before the deadline.</li>
                          <li>Please make DD or transfer payable to India Exposition Mart Limited</li>
                        </ul>

                        {/* Tariff Table */}
                        <div style={{ marginBottom: "14px" }}>
                        <strong><p className="m-0 mb-2">Tariff for Housekeeping Services:</p></strong>
                        <div className="table-responsive">
                          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <thead>
                              <tr>
                                <th className="text-center">Sr. No</th>
                                <th className="text-center">Date</th>
                                <th className="text-center">No. Of Cleaner Day (A)</th>
                                <th className="text-center">No. Of Cleaner Night (B)</th>
                                <th className="text-center">Rate per Guard ({CurrencyID === 1 ? 'INR' : 'USD'})</th>
                                <th className="text-center">Amount C = (A+B)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tariffList.length > 0 ? tariffList.map((row, index) => (
                                <tr key={row.HouseKeepingId}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">
                                    {row.Date ? moment(row.Date).format('DD/MM/YYYY') : '-'}
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="number"
                                      className="form-control text-center"
                                      style={{ minWidth: '80px' }}
                                      value={row.NoOfCleanerDay}
                                      min={0}
                                      disabled={is_View || isDeadlinePassed || StatusID == 2}
                                      onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                      onChange={(e) => this.handleTariffChange(index, 'NoOfCleanerDay', e.target.value)}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <input
                                      type="number"
                                      className="form-control text-center"
                                      style={{ minWidth: '80px' }}
                                      value={row.NoOfCleanerNight}
                                      min={0}
                                      disabled={is_View || isDeadlinePassed || StatusID == 2}
                                      onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                      onChange={(e) => this.handleTariffChange(index, 'NoOfCleanerNight', e.target.value)}
                                    />
                                  </td>
                                  <td className="text-center">{row.Rate != null ? row.Rate.toLocaleString() : '-'}</td>
                                  <td className="text-center">{row.Amount ? row.Amount.toLocaleString() : 0}</td>
                                </tr>
                              )) : (
                                <tr><td colSpan={6} className="text-center">No rate entries found. Please contact admin.</td></tr>
                              )}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan={5} className="text-end"><strong>Amount</strong></td>
                                <td className="text-center"><strong>{tariffTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong></td>
                              </tr>
                              {IsIGST === 1 ? (
                                <tr>
                                  <td colSpan={5} className="text-end"><strong>IGST @ 18%</strong></td>
                                  <td className="text-center">{igst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                </tr>
                              ) : (
                                <>
                                  <tr>
                                    <td colSpan={5} className="text-end"><strong>CGST @ 9%</strong></td>
                                    <td className="text-center">{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                  <tr>
                                    <td colSpan={5} className="text-end"><strong>SGST @ 9%</strong></td>
                                    <td className="text-center">{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td colSpan={5} className="text-end"><strong>Total Amount</strong></td>
                                <td className="text-center"><strong>{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong></td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                      </div>
                    )}

                    {!isHideSection && (
                      <div class="table-responsive">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th colSpan={2}>Bank Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Bank Name</strong>
                              </td>
                              <td>{BankName != null ? BankName : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Beneficiary Name</strong>
                              </td>
                              <td>{BeneficiaryName != null ? BeneficiaryName : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Beneficiary Address</strong>
                              </td>
                              <td>{BeneficiaryAddress != null ? BeneficiaryAddress : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Account No</strong>
                              </td>
                              <td>{AccountNumber != null ? AccountNumber : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Swift Code</strong>
                              </td>
                              <td>{SwiftCode != null ? SwiftCode : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>IFSC Code</strong>
                              </td>
                              <td>{IFSCCodeValue != null ? IFSCCodeValue : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>PAN No</strong>
                              </td>
                              <td>{PANNumber != null ? PANNumber : "-"}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>GST No</strong>
                              </td>
                              <td>{GSTNumber != null ? GSTNumber : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div className="mt-4">
                      <strong>
                        <p className="m-0">Quantity</p>
                      </strong>
                      <p className="m-0 p-1" style={{ backgroundColor: "#ebebeb" }}>
                        <input
                          type="text"
                          className="form-control w-30"
                          value={Quantity}
                          disabled={is_View || isDeadlinePassed || StatusID == 2}
                          onChange={(e) =>
                            this.setState({ Quantity: e.target.value.replace(/\D/, "") })
                          }
                          maxLength={30}
                        />
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row m-1">
                  <form>
                    <strong>
                      {" "}
                      <label>Remark</label>
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      disabled={is_View || isDeadlinePassed || StatusID == 2}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      maxLength={300}
                      rows="3"
                    ></textarea>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <strong>
                        {" "}
                        I agree the above disclaimer & Service Partner Terms and conditions
                        mentioned in Guideline<span className="required">*</span>.
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                  </form>
                </div>
              </div>
              <div className="row">
                {isDeadlinePassed && (
                  <span className="text-danger">
                    THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                  </span>
                )}
              </div>
              {!isHideSection && (
                <div className="d-flex gap-1 justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    style={{ marginRight: 10 }}
                    disabled={isDeadlinePassed || StatusID == 2}
                    // onClick={() => this.insertUpdateHouseKeeping()}
                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                  >
                    {this.state.StatusID == 0 ? "Submit" : "Update"}
                  </button>
                  <button
                    className="btn rounded-1 d-block mt-3 mb-3 btn-gray"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { getHouseKeepingDefaultDetails_action, getHouseKeepingDetails_action, insertUpdateHouseKeeping_action })(HousekeepingConnection));